import React, {useEffect, useState} from "react";
import {Alert, Col, Container, Row} from "react-bootstrap";
import CustomPagination from "../../common/CustomPaginaton";
import {UserModalForm} from "./UserModalForm";
import Modals from "../../../components/modals";
import SearchUsers from "./SearchUsers";
import UpdateUser from "./UpdateUser";
import Spinner from "react-bootstrap/Spinner";
import ProgressBar from "react-bootstrap/ProgressBar";
import {
    activateDeactivate,
    createUser,
    getUsers,
    getValues,
    search,
    updateMultipleUser,
    updateUser
} from "../../../actions/admin/userManagementActions";
import {useAuth} from "../../../context/authContext";
import {newUser} from "../../../utils/Models";
import {useDispatch, useSelector} from "react-redux";
import {clientToStateMap} from "../../../utils/textValueLists";
import SuccessToast from "../../common/SuccessToast";
import {UPDATE_SUCCESS} from "../../../actions/types";

const componentName = "UserManagement";
const ADD_USER = "ADD USER";
const UPDATE_USER = "UPDATE USER";
const BULK_UPDATE_USER = "BULK UPDATE USER";

const getSuccessMessage = (modalType) => {
  if (modalType === ADD_USER) {
    return "User created successfully.";
  }
  if (modalType === UPDATE_USER) {
    return "User updated successfully.";
  }
  return "Users updated successfully.";
};

const omitProviderNpi = (user) => {
  const { npi, providerNpi, ...userWithoutProviderNpi } = user || {};
  return userWithoutProviderNpi;
};

export const UserManagement = () => {
  const isEmpty = require("is-empty");
  const dispatch = useDispatch();
  const {
    currentUsers,
    userCreateDropDownValues,
    pageNumber,
    totalSize,
    pageSize,
    reloadPage,
    loading,
  } = useSelector((state) => state.userManagement);

  const roles = userCreateDropDownValues?.userRoles ?? [];
  const organizations = userCreateDropDownValues?.organizations ?? [];
  const accessTypes = userCreateDropDownValues?.accessTypes ?? [];
  const clients = userCreateDropDownValues?.clients ?? [];

  const [modalShow, setModalShow] = useState(false); //Toggles Modal Display
  const [modalType, setModalType] = useState(ADD_USER); // Value Changes By Which Btn Is Clicked
  const [sortedUsers, setSortedUsers] = useState(null); // Handles Displayed Users, As Well As Set The Search Results
  // Data Structure For New User, Needs to Hopefully be Refactored in Future
  const [userData, setUserData] = useState();

  const auth = useAuth();
  const token = auth.getAuthToken();

  const [searchParam, setSearchParam] = useState();
  let [usersToActivateOrD, setUsersToActivateOrD] = useState([]);
  let [enableActDeactButton, setEnableActDeactButton] = useState();
  const [strForConfirmDisplay, setStrForConfirmDisplay] = useState();
  const errors = useSelector((state) => state.errors);
  const success = useSelector((state) => state.success);
  const [errorToDisplay, setErrorToDisplay] = useState();
  const [sortOrder, setSortOrder] = useState({});

  const [regError, setRegError] = useState({});
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [newClients, setNewClients] = useState([]);

  const [showAddUpdateButtons, setShowAddUpdateButtons] = useState(false);

  const handleCloseForConfirmation = () => {
    let action = "";
    if (usersToActivateOrD && usersToActivateOrD.length > 0) {
      if (strForConfirmDisplay === "Activate") {
        action = "activate-users";
      } else if (strForConfirmDisplay === "Deactivate") {
        action = "deactivate-users";
      }
      dispatch(activateDeactivate(usersToActivateOrD, action, token));
    }
    setShowConfirm(false);
  };
  const updateStatus = (str) => {
    setStrForConfirmDisplay(str);
    setShowConfirm(true);
  };
  //Use Effects Starts
  useEffect(() => {
    if (!currentUsers.length && isEmpty(pageSize)) {
      dispatch(getUsers(token));
    }
      setUsersToActivateOrD([]);
      setSortedUsers(currentUsers);
  }, [currentUsers, dispatch, isEmpty, pageSize, token]);

  useEffect(() => {
    dispatch(getValues(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (clients?.length) {
      setNewClients(clients.map((e) => ({ "text": clientToStateMap[e], "value": e })))
    }
  }, [clients]);

  useEffect(() => {
    if (
      !isEmpty(userCreateDropDownValues) &&
      roles.length &&
      organizations.length &&
      accessTypes.length &&
      clients.length
    ) {
      setShowAddUpdateButtons(true);
    }
  }, [accessTypes.length, clients.length, isEmpty, organizations.length, roles.length, userCreateDropDownValues]);

  useEffect(() => {
    if (!isEmpty(errors)) {
      let errorMessage;
      if (errors && typeof errors == "string") {
        errorMessage = errors;
      } else if (errors?.message) {
        errorMessage = errors.message;
      } else {
        errorMessage = null;
      }
      setErrorToDisplay(errorMessage);
    }
  }, [errors, isEmpty]);

  //Use Effects Ends

  //Sets Modal Data, Type, & Displays
  const handleModal = (str, user = newUser) => {
    setErrorToDisplay(null);
    setShowValidationErrors(false);
    setRegError({});
    setModalType(str);
    setUserData(user);
    setModalShow(true);
  };

  const handleUserModalClose = () => {
    setModalShow(false);
    setShowValidationErrors(false);
    setRegError({});
  };

  const getUpdatedUserObject = () => {
    const userDataWithoutProviderNpi = omitProviderNpi(userData);
    if (userDataWithoutProviderNpi?.identifier && userDataWithoutProviderNpi.accessType) {
      const identifier = {};
      const arrIdentifier = userDataWithoutProviderNpi.identifier.split(",");
      identifier[userDataWithoutProviderNpi.accessType] = arrIdentifier;
      return { ...userDataWithoutProviderNpi, identifiers: identifier };
    }
    return { ...userDataWithoutProviderNpi, identifiers: null };
  };

  const saveUser = (updatedUserObj) => {
    if (modalType === ADD_USER) {
      return Promise.resolve(dispatch(createUser(updatedUserObj, token)));
    }
    if (modalType === UPDATE_USER) {
      return Promise.resolve(dispatch(updateUser(updatedUserObj, token)));
    }
    if (modalType === BULK_UPDATE_USER) {
      const prms = { userAccountIds: usersToActivateOrD, ...updatedUserObj };
      return Promise.resolve(dispatch(updateMultipleUser(prms, token)));
    }
    return Promise.resolve(null);
  };

  const handleSuccessfulSave = () => {
    setModalShow(false);
    setShowValidationErrors(false);
    setUserData({ ...newUser });
    dispatch({ type: UPDATE_SUCCESS, payload: getSuccessMessage(modalType) });
  };

  const handleCreation = async () => {
    const updatedUserObj = getUpdatedUserObject();
    if (validateForm(updatedUserObj, modalType)) {
      setShowValidationErrors(true);
      setErrorToDisplay("Please select all the required fields");
    } else {
      const actionResult = await saveUser(updatedUserObj);
      if (actionResult) {
        handleSuccessfulSave();
      }
    }
  };

  useEffect(() => {
    const reloadPageCall = async () => {
      const prms = { page: pageNumber, pageSize: 10, filters: searchParam };
      dispatch(search(prms, token));
    }
    reloadPageCall().catch(console.log)
  }, [dispatch, pageNumber, reloadPage, searchParam, token]);



  const validateForm = (updatedUserObj, modalType) => {
    let bulkValidation =
      isEmpty(updatedUserObj.accessType) ||
      (updatedUserObj.accessType !== 'NETWORK' && isEmpty(updatedUserObj.identifier)) ||
      isEmpty(updatedUserObj.client) ||
      updatedUserObj.client.length === 0 ||
      isEmpty(updatedUserObj.organization?.id) ||
      isEmpty(updatedUserObj.userRole?.id);
    if (modalType === BULK_UPDATE_USER) {
      return bulkValidation;
    }
    return (
      bulkValidation ||
      isEmpty(updatedUserObj.firstName) ||
      isEmpty(updatedUserObj.lastName) ||
      isEmpty(updatedUserObj.email)
    );
  };

  // Handles Chnage of userData
  // Due To The Nested Objects && Arrays Of Objects The Setting Of userData's State Is More Ribose
  const handleUserFormChange = (e) => {
    if (e?.paramName === 'Clients') {
      setUserData({
        ...userData,
        client: e.paramValue,
      });
    }
    else {
      const { name, value } = e.target;
      setRegError((prev) => {
        const next = { ...prev };
        if (name && e?.error) {
          if (prev[name] === e.error) {
            return prev;
          }
          next[name] = e.error;
        } else {
          if (!prev[name]) {
            return prev;
          }
          delete next[name];
        }
        return next;
      });
      if (
        name === "firstName" ||
        name === "lastName" ||
        name === "email" ||
        name === "accessType" ||

        name === "accountActive" ||
        name === "identifier" ||
        name === "organization"
      ) {
        setUserData({
          ...userData,
          [name]: value,
        });
      }
      if (name === "userRole") {
        const obj = JSON.parse(value);
        setUserData({
          ...userData,
          [name]: {
            id: obj.id,
            name: obj.name,
          },
        });
      }
    }
  };
  const sortCol = (att, desc, page = 1) => {
    const prm = {
      page,
      pageSize: 10,
      filters: searchParam,
      sortingCriteria: [
        {
          sortAttribute: att,
          desc: desc,
        },
      ],
    };
    dispatch(search(prm, token));
  };

  const searchTable = (params) => {
    const isEmpty = Object.values(params).every((x) => x === "");
    let filters = [];
    if (!isEmpty) {
      for (let [key, value] of Object.entries(params)) {
        if (value.length && key !== "roleName") {
          filters.push({
            fieldName: key,
            value: value,
            comparisonMode: "EQUAL_TO",
          });
        }
      }
    }
    const prms = { page: 1, pageSize: 10, filters: filters };
    setSearchParam(filters);
    dispatch(search(prms, token));
    setSortOrder({});
  };

  const paginate = (i) => {
    if (i) {
      const prms = { page: i, pageSize: 10, filters: searchParam };

      if (sortOrder?.el) {
        sortCol(sortOrder.el, sortOrder.so, i)
      } else {
        dispatch(search(prms, token));
      }
    }
  };

  const handleChangeCheckBox = (e, userAccountId) => {
    const { checked } = e.target;
    if (checked && !usersToActivateOrD.includes(userAccountId)) {
      const nextUsersToActivateOrD = [...usersToActivateOrD, userAccountId];
      setUsersToActivateOrD(nextUsersToActivateOrD);
      setEnableActDeactButton(nextUsersToActivateOrD.length > 0);
    } else {
      const nextUsersToActivateOrD = usersToActivateOrD.filter((id) => id !== userAccountId);
      setUsersToActivateOrD(nextUsersToActivateOrD);
      setEnableActDeactButton(nextUsersToActivateOrD.length > 0);
    }
  };
  return (
    <Container fluid>
      <Row className="py-3">
        <Col>
          {success?.message && <SuccessToast />}
          <Modals
            show={modalShow}
            onHide={handleUserModalClose}
            onCreate={handleCreation}
            title={modalType}
            titleid={`${componentName}`}
            size="xl"
            hideFooter={false}
            completeBtn={"SAVE CHANGES"}
            completeBtnId={`${componentName}-completeButton`}
            closeBtnId={`${componentName}-closeButton`}
            disabledClickButton={!isEmpty(regError)}
            body={
              <UserModalForm
                type={modalType}
                handleChange={handleUserFormChange}
                user={userData}
                roles={roles}
                organizations={organizations}
                accessTypes={accessTypes}
                clients={newClients}
                closeBtnId={`${componentName}-closeButton`}
                regError={regError}
                showValidationErrors={showValidationErrors}
              />
            }
          />
          <SearchUsers
            submitSearchPrameters={searchTable}
            roles={roles}
            accessTypes={accessTypes}
          />
          {loading && isEmpty(errors) && <ProgressBar animated now={95} />}

          <Modals
            show={!isEmpty(errorToDisplay)}
            onHide={() => setErrorToDisplay(null)}
            title={<span>Error</span>}
            titleid={`${componentName}-error`}
            size="md"
            hideClickButton={true}
            hideFooter={false}
            body={<Alert variant="danger">{errorToDisplay}</Alert>}
          />
          {!isEmpty(sortedUsers) && sortedUsers.length > 0 && (
            <UpdateUser
              updateStatus={updateStatus}
              handleModal={handleModal}
              users={sortedUsers}
              handleChangeCheckBox={handleChangeCheckBox}
              showAddUpdateButtons={showAddUpdateButtons}
              enableActDeactButton={enableActDeactButton}
              roles={roles}
              sortCol={sortCol}
              setSortOrder={setSortOrder}
            />
          )}

          {isEmpty(sortedUsers) && (
            <div>
              {" "}
              <Spinner animation="grow" />
            </div>
          )}

          {!isEmpty(sortedUsers) && Math.ceil(totalSize / pageSize) > 0 && (
            <CustomPagination
              paginateButClicked={paginate}
              MAX_PAGE={Math.ceil(totalSize / pageSize)}
              pageNumber={Math.ceil(pageNumber)}
            />
          )}

          <Modals
            show={showConfirm}
            hideFooter={false}
            onHide={() => setShowConfirm(false)}
            onCreate={handleCloseForConfirmation}
            title={"Confirmation"}
            titleid={`${componentName}-confirmation`}
            size="sm"
            completeBtn={strForConfirmDisplay}
            completeBtnId={`${componentName}-confirmButton`}
            closeBtnId={`${componentName}-closeButton`}
            body={<span>Are you Sure you want to {strForConfirmDisplay} ? </span>}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default UserManagement;
